// ProtectedRoutes.jsx
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoutes() {
  const isAuthenticated = Boolean(localStorage.getItem("token")); // your auth logic
  // return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
  return <Outlet />
}
